"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextModule = void 0;

/**
 * Master list of context modules available in web and iOS
 *
 * A component where an action is triggered
 * @packageDocumentation
 */
let ContextModule;
/**
 * Limited ContextModules available for web authentication events
 */

exports.ContextModule = ContextModule;

(function (ContextModule) {
  ContextModule["aboutTheWork"] = "aboutTheWork";
  ContextModule["artistCard"] = "artistCard";
  ContextModule["artistHeader"] = "artistHeader";
  ContextModule["artistHighDemandGrid"] = "artistHighDemandGrid";
  ContextModule["artistRecentlySold"] = "artistRecentlySold";
  ContextModule["artistSeriesRail"] = "artistSeriesRail";
  ContextModule["artistsTab"] = "artistsTab";
  ContextModule["artistsToFollowRail"] = "artistsToFollowRail";
  ContextModule["artworkGrid"] = "artworkGrid";
  ContextModule["artworkImage"] = "artworkImage";
  ContextModule["artworkRecentlySoldGrid"] = "artworkRecentlySoldGrid";
  ContextModule["artworkSidebar"] = "artworkSidebar";
  ContextModule["auctionSidebar"] = "auctionSidebar";
  ContextModule["auctionCard"] = "auctionCard";
  ContextModule["auctionRail"] = "auctionRail";
  ContextModule["auctionResults"] = "auctionResults";
  ContextModule["auctionsInfo"] = "auctionsInfo";
  ContextModule["bannerPopUp"] = "bannerPopUp";
  ContextModule["browseFair"] = "browseFair";
  ContextModule["categoryRail"] = "categoryRail";
  ContextModule["cityGuideCard"] = "cityGuideCard";
  ContextModule["collectionDescription"] = "collectionDescription";
  ContextModule["collectionRail"] = "collectionRail";
  ContextModule["collectionCard"] = "collectionCard";
  ContextModule["consignSubmissionFlow"] = "consignSubmissionFlow";
  ContextModule["currentShowsRail"] = "currentShowsRail";
  ContextModule["fairInfo"] = "fairInfo";
  ContextModule["fairsHeader"] = "fairsHeader";
  ContextModule["fairRail"] = "fairRail";
  ContextModule["fairCard"] = "fairCard";
  ContextModule["featuredArtists"] = "featuredArtists";
  ContextModule["featuredArtistsRail"] = "featuredArtistsRail";
  ContextModule["featuredCollection"] = "featuredCollection";
  ContextModule["featuredViewingRoomsRail"] = "featuredViewingRoomsRail";
  ContextModule["footer"] = "footer";
  ContextModule["geneHeader"] = "geneHeader";
  ContextModule["header"] = "header";
  ContextModule["intextTooltip"] = "intextTooltip";
  ContextModule["latestViewingRoomsRail"] = "latestViewingRoomsRail";
  ContextModule["liveAuctionsRail"] = "liveAuctionsRail";
  ContextModule["mainCarousel"] = "mainCarousel";
  ContextModule["minimalCTABanner"] = "minimalCTABanner";
  ContextModule["moreFromThisSeries"] = "moreFromThisSeries";
  ContextModule["moreSeriesByThisArtist"] = "moreSeriesByThisArtist";
  ContextModule["newWorksByArtistsYouFollowRail"] = "newWorksByArtistsYouFollowRail";
  ContextModule["newWorksByGalleriesYouFollowRail"] = "newWorksByGalleriesYouFollowRail";
  ContextModule["otherWorksByArtistRail"] = "otherWorksByArtistRail";
  ContextModule["otherWorksFromPartnerRail"] = "otherWorksFromPartnerRail";
  ContextModule["otherWorksFromShowRail"] = "otherWorksFromShowRail";
  ContextModule["otherWorksInAuctionRail"] = "otherWorksInAuctionRail";
  ContextModule["partnerHeader"] = "partnerHeader";
  ContextModule["pastFairs"] = "pastFairs";
  ContextModule["popularArtistsRail"] = "popularArtistsRail";
  ContextModule["popUpModal"] = "popUpModal";
  ContextModule["promoSpace"] = "promoSpace";
  ContextModule["recentlySavedRail"] = "recentlySavedRail";
  ContextModule["recentlyViewedRail"] = "recentlyViewedRail";
  ContextModule["recommendedArtistsRail"] = "recommendedArtistsRail";
  ContextModule["recommendedWorksForYouRail"] = "recommendedWorksForYouRail";
  ContextModule["relatedArtistsRail"] = "relatedArtistsRail";
  ContextModule["relatedWorksRail"] = "relatedWorksRail";
  ContextModule["saveWorksCTA"] = "saveWorksCTA";
  ContextModule["sellFooter"] = "sellFooter";
  ContextModule["sellHeader"] = "sellHeader";
  ContextModule["showHeader"] = "showHeader";
  ContextModule["showInfo"] = "showInfo";
  ContextModule["similarToWorksYouSavedRail"] = "similarToWorksYouSavedRail";
  ContextModule["similarToWorksYouViewedRail"] = "similarToWorksYouViewedRail";
  ContextModule["tabBar"] = "tabBar";
  ContextModule["tagHeader"] = "tagHeader";
  ContextModule["topWorksRail"] = "topWorksRail";
  ContextModule["trendingArtistsRail"] = "trendingArtistsRail";
  ContextModule["viewingRoom"] = "viewingRoom";
  ContextModule["worksByPopularArtistsRail"] = "worksByPopularArtistsRail";
  ContextModule["worksForSaleRail"] = "worksForSaleRail";
})(ContextModule || (exports.ContextModule = ContextModule = {}));